export default {
    data() {
      return {
        activeAlarmList: [],
        activeAlarmAudioInterval: 0,
        alarmAudio: null,
      };
    },
    methods: {
      alarmActive(topic) {
        if (!this.activeAlarmList.includes(topic)) this.activeAlarmList.push(topic);
      },
      removeAlarm(topic) {
        this.activeAlarmList = this.activeAlarmList.filter(t => t !== topic);
      },
    },
    mounted() {
      this.alarmAudio = new Audio('../alarm.mp3');
    },
    watch: {
      activeAlarmList() {
        if (this.activeAlarmList.length > 0) {
          if (this.activeAlarmAudioInterval === 0) {
            this.activeAlarmAudioInterval = setInterval(() => {
              if (this.alarmAudio) {
                this.alarmAudio.currentTime = 0;
                this.alarmAudio.play().catch(() => {});
              }
            }, 1000);
          }
        } else {
          clearInterval(this.activeAlarmAudioInterval);
          this.activeAlarmAudioInterval = 0;
          if (this.alarmAudio) this.alarmAudio.pause();
        }
      },
    },
    beforeDestroy() {
      clearInterval(this.activeAlarmAudioInterval);
    },
  };
  